module.exports = __webpack_public_path__ + "img/unknown.e03e3fac.jpg";